(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  // 1) Klick auf Link im <summary>: NICHT das Dropdown toggeln, sondern normal navigieren
document.addEventListener('click', function (e) {
  const linkInSummary = e.target.closest('summary a.list-menu__item--link');
  if (!linkInSummary) return;
  e.preventDefault();
  e.stopPropagation();
  window.location.href = linkInSummary.href;
});

// Verhindere, dass ein Klick auf den Link im <summary> das <details> toggelt:
document.addEventListener('click', function (e) {
  const linkInSummary = e.target.closest('summary a.js-summary-link');
  if (!linkInSummary) return;
  e.preventDefault();
  e.stopPropagation();
  window.location.href = linkInSummary.href;
});

// Sorge dafür, dass NUR der Pfeil (Caret) toggelt:
document.addEventListener('click', function (e) {
  const toggle = e.target.closest('summary .js-submenu-toggle');
  if (!toggle) return;
  const details = toggle.closest('details');
  if (!details) return;

  const open = details.hasAttribute('open');
  // Option: andere auf gleicher Ebene schließen
  details.parentElement?.querySelectorAll(':scope > details[open]')?.forEach(d => {
    if (d !== details) d.removeAttribute('open');
  });

  if (open) {
    details.removeAttribute('open');
  } else {
    details.setAttribute('open', '');
  }
});

// 2) Nur der Pfeil (span.submenu-toggle) soll das Dropdown öffnen/schließen
document.addEventListener('click', function (e) {
  const toggle = e.target.closest('summary .submenu-toggle');
  if (!toggle) return;
  const details = toggle.closest('details');
  if (!details) return;

  const isOpen = details.hasAttribute('open');

  // Optional: auf gleicher Ebene andere schließen
  details.parentElement?.querySelectorAll(':scope > li details[open]')?.forEach(d => {
    if (d !== details) d.removeAttribute('open');
  });

  if (isOpen) {
    details.removeAttribute('open');
  } else {
    details.setAttribute('open', '');
  }
});

// 3) Tastaturzugänglichkeit für den Pfeil (Enter/Space)
document.addEventListener('keydown', function (e) {
  if (!['Enter', ' '].includes(e.key)) return;
  const isToggle = e.target.matches('summary .submenu-toggle');
  if (!isToggle) return;
  e.preventDefault();
  e.target.click();
});

  } catch(e) { console.error(e); }
})();
})();
